import React, {FC, useMemo} from 'react';

import {makeGetAvailableTicketStatuses} from '../../../../libs/inboxes/store/src/ticketing/ticketStatusSelectors';
import {FrontEvent} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {TicketStatusModel} from '../../../../libs/shared/core/src/models/api/ticketStatusModel';
import {DropdownInheritableProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {TicketStatusDropdown} from './ticketStatusDropdown';

/*
 * Props.
 */

interface TicketStatusDropdownContainerProps extends DropdownInheritableProps {
  isArchiveAllowed?: boolean;
  selectedTicketStatusTagId: number | undefined;
  onTicketStatusSelect: (event: FrontEvent, ticketStatus: TicketStatusModel) => void;
  openedByKeyboardAction?: boolean;
}

/*
 * Component.
 */

export const TicketStatusDropdownContainer: FC<TicketStatusDropdownContainerProps> = (props) => {
  const getAvailableTicketStatuses = useMemo(
    () => makeGetAvailableTicketStatuses(getSelectedTicketStatusTagId),
    [],
  );
  const ticketStatuses = useAppSelector((state) => getAvailableTicketStatuses(state, props));

  // This dropdown should only be rendered when ticketing is provisioned.
  // TODO: Render an error state, just in case.
  if (!ticketStatuses) {
    return null;
  }

  const {
    isArchiveAllowed,
    selectedTicketStatusTagId,
    onTicketStatusSelect,
    openedByKeyboardAction,
    ...popoverProps
  } = props;

  return (
    <TicketStatusDropdown
      {...popoverProps}
      openedByKeyboardAction={openedByKeyboardAction}
      ticketStatuses={ticketStatuses}
      isArchiveAllowed={isArchiveAllowed}
      selectedTicketStatusTagId={selectedTicketStatusTagId}
      onTicketStatusSelect={onTicketStatusSelect}
    />
  );
};

/*
 * Selectors.
 */

const getSelectedTicketStatusTagId = (_: unknown, params: TicketStatusDropdownContainerProps) =>
  params.selectedTicketStatusTagId;
